import { render } from "./ReportPage1.vue?vue&type=template&id=3f35e44d&ts=true"
import script from "./ReportPage1.vue?vue&type=script&lang=ts"
export * from "./ReportPage1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__